import { render, staticRenderFns } from "./ChoferLinea.vue?vue&type=template&id=3f260bd4"
import script from "./ChoferLinea.vue?vue&type=script&lang=js"
export * from "./ChoferLinea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports